import { useMutation, useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { AuthContext } from "../providers/AuthProvider";
import { getUnreadMessages, readMessage } from '../providers/BasejumpApiProvider';

/**
 * Query to fetch a mission by id
 * @param {number} id - The id of the mission
 * @returns UseQueryResult
 */
export function useMessages(opts = {}) {
  const { user, basejumpToken } = useContext(AuthContext);

  return useQuery({
    queryKey: ["user-messages", user],
    queryFn: async () => getUnreadMessages(basejumpToken),
    enabled: Boolean(basejumpToken) ,
    ...opts
  });
}

export function useReadMessage() {
  const { basejumpToken } = useContext(AuthContext);

  return useMutation({
    mutationFn: async ({ messageId }) => readMessage(basejumpToken, messageId),
  });
}
